<template>
  <v-main>
    <DetailsDialog ref="dialog" @reload="$refs.report.reload()" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="selectRow"
      :selectable="true"
      @update:selected="(v) => (selectedIds = v)"
      :rememberLastClick="true"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn color="primary" @click="newRow">
          Nova câmera...
        </v-btn>
        <OMenuButton :menuOpts="menuOpts" />
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import { Camera } from './cameras-fetcher'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import DetailsDialog from './DetailsDialog.vue'
import { brDt } from 'oderon-commons/src/formatters.js'

export default {
  pageTitle: 'Câmeras JIMI',
  components: {
    GenericReport,
    DetailsDialog
  },
  data() {
    return {
      reportSpec: {
        title: 'Câmeras JIMI',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar inativas',
            defVal: false
          }
        ]
      },
      adapterSpec: {
        defOrder: 'name asc',
        defCodes: ['id', 'name', 'imei', 'orgName', 'vehicleCode', 'updatedAt'],
        columns: [
          { t: 'ID|', w: 100, d: 'id', color: '#cccccc' },
          { t: 'Nome', d: 'name' },
          { t: 'IMEI', d: 'imei' },
          { t: 'Modelo', d: 'model' },
          { t: 'Lote', d: 'batchNumber', selectable: true },
          { t: 'Organização', code: 'orgName', d: 'vehicle.org.label' },
          { t: 'Veículo', code: 'vehicleCode', d: 'vehicle.code' },
          {
            t: 'Criado em|',
            d: 'createdAt',
            f: brDt,
            w: 250,
            selectable: true
          },
          {
            t: 'Atualizado em|',
            d: 'updatedAt',
            f: brDt,
            w: 250,
            selectable: true
          },
          {
            t: 'Desativado em|',
            d: 'deletedAt',
            f: brDt,
            w: 250,
            selectable: true
          }
        ]
      },

      // checkboxes marcados
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      let len = this.selectedIds.length
      return [
        {
          text: 'Desativar...',
          onClick: () => this.confirmDelete(),
          disabled: len < 1
        },
        // {
        //   text: 'Duplicar...',
        //   onClick: () => this.duplicate(),
        //   disabled: len !== 1
        // },
        {
          text: 'Exportar CSV',
          onClick: () => this.$refs.report.downloadCsv()
        }
        // ,
        // { isDivider: true },
        // {
        //   text: 'Status das Conexões',
        //   onClick: () => this.$refs.connDialog.open()
        // }
      ]
    }
  },
  methods: {
    async fetchData({ keywords, includeInactive } = {}) {
      let { count, rows } = await Camera.findAll({ keywords, includeInactive })
      return { count, rows }
    },

    async newRow() {
      let label = 'Digite o IMEI da nova câmera'
      let imei = await this.$prompt({ label })
      if (imei != null) {
        let row = await this.$loading(async () => {
          return Camera.save({ imei })
        })
        this.$refs.report.reload()
        if (row != null) this.selectRow({ row })
      }
    },

    async selectRow({ row, isMiddle }) {
      if (isMiddle) {
        window.open(`/#/setup/cameras/${row.id}`, '_blank')
      } else {
        const res = await this.$refs.dialog.open(row.id)
        if (res === 'RELOAD') this.$refs.report.reload()
      }
    },

    async confirmDelete() {
      let res = await this.$confirmDeactivate({
        strings: 'câmera;a',
        len: this.selectedIds.length
      })

      if (res) {
        this.$loading(async () => {
          for (let id of this.selectedIds) {
            await Camera.delete(id)
          }
          this.selectedIds = []
          this.$snack('Desativada(s) com sucesso')
          this.$refs.report.reload()
        })
      }
    }
  }
}
</script>

<style></style>
